<template>
  <div v-if="model?.latest_email_sent" class="flex min-w-50 flex-col space-y-1">
    <div class="flex items-center gap-x-2">
      <div v-if="emailTitle" class="flex items-center space-x-2 truncate">
        <div class="h-4 w-4">
          <icon-base :icon="IconEmail" class="text-turquoise" />
        </div>
        <div v-tooltipable class="truncate">{{ emailTitle }}</div>
      </div>
      <avatar-with-name
        v-if="model.latest_email_sent.sender_name"
        class="truncate"
        :user="user"
        :text-to-size-ratio="0.58"
        :styles="{ textClass: 'truncate text-gray-800' }"
      />
    </div>
    <div class="text-label" data-cy="last-call-column-date">
      <date-and-time-display
        :value="model.latest_email_sent.timestamp || ''"
        :show-time-below-date="false"
      />
    </div>
  </div>
  <div v-else>-</div>
</template>
<script setup lang="ts">
import { computed } from "vue";

import IconEmail from "@/components/icons/IconEmail.vue";
import AvatarWithName from "@/components/ui/AvatarWithName.vue";
import DateAndTimeDisplay from "@/components/ui/text/DateAndTimeDisplay.vue";

import type { LatestSentEmail } from "@/models/applications";

interface Props {
  model: { latest_email_sent: LatestSentEmail | null };
}

const props = defineProps<Props>();

const user = computed(() => {
  const sender = props.model?.latest_email_sent?.sender_name ?? "";
  const [firstName, lastName] = sender.split(" ");
  return { first_name: firstName ?? "", last_name: lastName ?? "" };
});

const emailTitle = computed(() => {
  return (
    props.model?.latest_email_sent?.template_name ||
    props.model?.latest_email_sent?.subject ||
    "-"
  );
});
</script>
